import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import styles from "./jss/material-dashboard-react/components/typographyStyle.js";

const useStyles = makeStyles(styles);

export default function Danger(props) {
  const classes = useStyles();
  const { children, color } = props;
  return (
    <div
      style={{ color: color }}
      className={classes.defaultFontStyle + " " + classes.dangerText}
    >
      {children}
    </div>
  );
}

Danger.propTypes = {
  children: PropTypes.node,
};
